import React, { useContext, useState } from "react";
import API from "../utils/api";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import Swal from "sweetalert2";
import bgImage from "../assets/airmax.webp";
import shoeImage from "../assets/shoe.png"; // rename the PNG file you uploaded

const Login = () => {
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);
  const [form, setForm] = useState({ username: "", password: "" });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await API.post("/login.php", form);
      const { token, user } = res.data;
      login(user, token);
      Swal.fire("✅ Login Success", "", "success");
      navigate("/dashboard");
    } catch (err) {
      Swal.fire("❌ Login Failed", err.response?.data?.error || "Server error", "error");
    }
  };

  return (
    <div
      className="min-h-screen bg-cover bg-center flex items-center justify-center"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="bg-black bg-opacity-70 rounded-xl shadow-lg p-10 w-full max-w-md text-white relative">
        <img
          src={shoeImage}
          alt="Nike Air"
          className="w-40 h-40 absolute -top-20 left-1/2 transform -translate-x-1/2 rounded-full shadow-lg border-4 border-white bg-white object-contain"
        />
        <h2 className="mt-24 text-3xl font-bold text-center mb-6 tracking-widest">Petrah collection LOGIN</h2>
        <form onSubmit={handleSubmit} className="space-y-5">
          <input
            type="text"
            name="username"
            value={form.username}
            onChange={handleChange}
            placeholder="Username or Email"
            className="w-full px-4 py-3 bg-white text-black rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500"
            required
          />
          <input
            type="password"
            name="password"
            value={form.password}
            onChange={handleChange}
            placeholder="Password"
            className="w-full px-4 py-3 bg-white text-black rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500"
            required
          />
          <div className="flex justify-between items-center text-sm">
            <label>
              <input type="checkbox" className="mr-1" />
              Remember Me
            </label>
            <a href="#" className="text-red-300 hover:underline">
              Forgot Password?
            </a>
          </div>
          <button
            type="submit"
            className="w-full py-3 bg-red-600 hover:bg-red-700 transition rounded-lg font-bold text-white"
          >
            Login
          </button>
        </form>
        <p className="mt-4 text-center text-sm text-gray-300">
          © 2025 Petrah collection | Powered by BDS POS
        </p>
      </div>
    </div>
  );
};

export default Login;
